import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb} from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'atw-block-footer-config',
  templateUrl: './block-footer-config.component.html',
  styleUrls: ['./block-footer-config.component.scss'],
})
export class AtwBlockFooterConfig implements OnInit {
  @Input() blockChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() position: any; // là dữ liệu position hoặc mobile_config từ database
  @Output() changeOptionConfig = new EventEmitter<any>();
  isViewAll: boolean = false;
 


  public openMenu: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
  };
  public currentViewAll: any = {};
  public stylesField = [
    {
      title: 'dieu_chinh_vien',
      index: 1,
    },
    {
      title: 'hieu_ung',
      index: 2,
    },
    {
      title: 'nang_cao',
      index: 3,
    }
  ];
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'Mặc định',
      deg: '180deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top,',
      name: 'tu_duoi_len_tren',
      deg: '0deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'Từ trái sang phải',
      deg: '90deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'Từ phải sang trái',
      deg: '270deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom right,',
      name: 'tu_trai_tren_sang_phai_duoi',
      deg: '135deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom left,',
      name: 'tu_phai_tren_sang_trai_duoi',
      deg: '225deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top right,',
      name: 'tu_trai_duoi_sang_phai_tren',
      deg: '45deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top left,',
      name: 'tu_phai_duoi_sang_trai_tren',
      deg: '315deg',
    },
  ];
  configUpdates: any = {
    "position_onscroll": {
      'type': 0,
      'top': 0
    },
    "background-color": {
			"gradient_arr": [
				"rgb(0, 0, 255)",
				"rgb(255, 255, 0)"
			],
			"background": "#8c52ff",
			"gradient_check": false,
			"value_range": 1,
			"gradient_type": "linear-gradient",
			"value_parameter": 100,
			"gradient_direction": ""
		}
  };
  effect_hover = []; // mảng tất cả các effects
  customize = [];
  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb, 
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    this.config.filter ??= {};
    this.config.filter.filter_opacity ??= 100;
    this.config.filter.filter_grayscale ??= 0;
    this.config.filter.filter_contrast ??= 100;
    this.config.filter.filter_blur ??= 0;
    this.config.filter.filter_saturate ??= 100;
    this.config.filter.filter_hue_rotate ??= 0;
    this.config.filter.filter_brightness ??= 100;
    
    // Kiểm tra nếu chưa có config thì thêm để người dùng không cần xóa thêm lại
    for (const key in this.configUpdates) {
      if (!this.config.hasOwnProperty(key)) {
        this.config[key] = this.configUpdates[key];
      } else {
        for (const key2 in this.configUpdates[key]) {
          if (!this.config[key].hasOwnProperty(key2)) {
            this.config[key][key2] = this.configUpdates[key][key2];
          }
        }
      }
    }

    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/block-blank.json')
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
    })
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['block-footer']['background-image'] = "linear-gradient(" + this.config['background-color']['gradient_direction'] + this.config['background-color']['gradient_arr'] + ")";
    }
    else {
      this.class['block-footer']['background-image'] = "none";
    }
    this.updateObject();
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient =
        this.device == 'desktop'
          ? this.config['background-color']
          : this.config['background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }
  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index) {
    if (this.config['background-color'][`gradient_arr`].length > 1) {
      this.config['background-color'][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb()
    }
  }

  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Get class active của element khi click chọn hướng phối màu.
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      var activeGradient = document.querySelector('.active') as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      this.config['background-color'].gradient_type = direction.type;
      this.config['background-color'].gradient_direction = direction.direction;
      this.class['block-footer']['background-image'] = this.config['background-color'].gradient_type + '(' + this.config['background-color'].gradient_direction + this.config['background-color'].gradient_arr.join(',') + ')'
      this.updateConfig();
      this.updateClass();
    }
  }

  openHandler(value: string): void {
    for (const key in this.openMenu) {
      if (key !== value) {
        this.openMenu[key] = false;
      }
    }
  }


  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  

  //Hàm update class
  updateClass() {
    this.vhQueryAutoWeb
      .updateBlock(this.blockChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {

      });
  }

  //Hàm update class
  updateConfig() {
    this.vhQueryAutoWeb
      .updateBlock(this.blockChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {

      });
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateBlock(this.blockChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        console.log('updateObject', bool);
      })
  }

  /**
   * update trường mobile_portrait_hidden or desktop_hidden cho frame
   * @param value
   */
  updateHidden(value) {
    this.vhQueryAutoWeb.updateBlock(this.blockChoosing._id, value).then(
      (bool) => {

      },
      (error) => {
        console.error(error);
      }
    );
  }
  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) {
      this.position['width'] = event.width;
      this.class['block-footer']['width'] = event.width + 'px';
    }
    if (event.height) {
      this.position['height'] = event.height;
      this.class['block-footer']['min-height'] = event.height + 'px';

    }
    this.updateClass()
    this.updatePosition()
  }

  //Hàm update position
  updatePosition() {
    this.vhQueryAutoWeb
      .updateBlock(this.blockChoosing._id, {
        [this.device + '_position_']: this.position,
      })
      .then((bool: any) => {
      });
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    // Nếu là hiệu ứng Pháo hoa / Tuyết rơi / Mưa rơi thì lưu thêm trường số lượng, ngược lại thì xóa
    if (['000005', '000006', '000007'].indexOf(this.config['animation-selected']['id']) != -1) {
      // Kiểm tra và khởi tạo giá trị mặc định của trường pieceCount nếu chưa có
      if (!this.config['animation-selected']['pieceCount']) {
        this.config['animation-selected']['pieceCount'] = 5;
        this.updateConfig();
      }
      // Nếu là Mưa rơi thì thêm config pieceDirection
      if (this.config['animation-selected']['id'] == '000007') {
        this.config['animation-selected']['pieceDirection'] = '0';
        this.updateConfig();
      }
      // Nếu là Pháo hoa và kiểm tra lớn hơn 10 thì trả về 10
      if (this.config['animation-selected']['id'] == '000005' && this.config['animation-selected']['pieceCount'] > 10) {
        this.config['animation-selected']['pieceCount'] = 10;
        this.updateConfig();
      }
      // Thông báo cho bên user để cập nhật pieceCount/pieceDirection
      // this.vhEventMediator.notifyOnConfigChanged({ _id: this.blockChoosing._id, code: this.blockChoosing._id, status: 'update-animation-selected-pieceCount' });
    }
    else {
      // Nếu không là Mưa rơi/Tuyết rơi/Pháo hoa thì xóa config pieceDirection
      delete this.config['animation-selected']['pieceCount'];
      if (this.config['animation-selected']['id']['pieceDirection']) {
        delete this.config['animation-selected']['pieceDirection'];
      }
      this.updateConfig();
    }
    this.customize = event;
    this.openViewAll(this.stylesField[1]);
  }


}
